{
  "CustomisePopupTitle": "Personalizzare il ruolo di amministratore",
  "FooterActionsSubmit": "Invia",
  "FooterActionsCancel": "Annullamento",
  "FooterActionsHelp": "Aiuto?",
  "TableHeadingAdminAccess": "Accesso all'amministrazione",
  "HeadingAdministrate": "Amministrare",
  "HeadingView": "Vista",
  "HeadingAdd": "Aggiungi",
  "HeadingModify": "Cambiamento",
  "HeadingDelete": "Cancellare",
  "EntryCme": "Gestione dell'ECM",
  "EntryDevices": "Dispositivi",
  "EntryDevicesSub": "(Estensioni \/ Gruppi \/ Altri dispositivi)",
  "EntryAgents": "Agenti",
  "EntryDirectory": "Elenchi",
  "EntryApplicationUsers": "Utenti dell'applicazione",
  "EntryCodes": "Codici",
  "EntryTelServers": "Server di telefonia",
  "EntryPartition": "Divisori",
  "EntryOmnichannel": "Omnichannel",
  "EntryRecordings": "Registrazione",
  "EntryMessages": "Messaggi",
  "EntryDatabase": "Database",
  "TableHeadingStatusTools": "Accesso allo stato e agli strumenti",
  "HeadingSection": "Sezione",
  "EntryLicences": "Licenze",
  "EntryLogging": "Registrazione",
  "EntryLogManagement": "Gestione dei registri",
  "EntryAuditTrail": "Traccia di controllo",
  "EntryTelephoneModuleStatus": "Stato del modulo telefonico",
  "EntryOmnichannelStatus": "Stato dell'Omnichannel",
  "EntryCallControl": "Controllo chiamate",
  "EntryServerStatus": "Stato del server",
  "TableHeadingActions": "Azioni",
  "HeadingAction": "Azione",
  "HeadingAllowed": "Consentito",
  "EntryCopyReportsTo": "Copia di rapporti a...",
  "EntrySignInAs": "Accedi come...",
  "EntryBillingFilesDownload": "CDR di fatturazione",
  "EntryBillingSummary": "Riepilogo della fatturazione",
  "EntryChangeLicenceLevel": "Modifica del livello di licenza",
  "SyncPartition": "Partizione di sincronizzazione",
  "ViewChangedWarning": "Senza l'opzione Visualizza, {} può essere {} solo utilizzando l'API.",
  "Update": "aggiornato",
  "Delete": "cancellato",
  "ViewChangeOr": " o ",
  "CustomiseRole_Add": "aggiunto",
  "NAME": "CustomiseRole",
  "EntryUserRole": "Ruoli utente",
  "EntryChangeTelephonyServerBillingStatus": "Modifica dello stato di fatturazione del server di telefonia",
  "EptAccess": "Strumento di provisioning semplice",
  "EntryLogFilesDownload": "Scarica i file di registro",
  "TelSysSyncRestrictions": "Modifica i parametri di sincronizzazione massima",
  "CMEBrandingConfig": "Configurazione del marchio CME",
  "EntryCrm": "Gestione CRM",
  "EntryClientConfig": "Configurazione del cliente",
  "EditOwningCMEDomainProfile": "Modifica il profilo del dominio CME",
  "EditOwningCMEBranding": "Modifica il marchio CME",
  "EditOwningCMEProvisioning": "Modifica provisioning CME (sincronizzazione Service Pack)"
}